var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExerciseExtremity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4998 1.66659L9.66647 7.24992L8.65814 6.38325L11.6581 4.64992L7.84147 0.833252L6.66647 2.00825L8.9498 4.29159L4.16647 7.04992L3.1748 10.6249L5.2248 14.1666L6.66647 13.3333L4.9748 10.3999L5.26647 9.31659L7.91647 10.8333L8.33314 18.3333H9.99981L10.4165 9.99992L17.4998 2.83325L16.4998 1.66659Z",
    fill: "#2F54EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 5.83333C5.08714 5.83333 5.83333 5.08714 5.83333 4.16667C5.83333 3.24619 5.08714 2.5 4.16667 2.5C3.24619 2.5 2.5 3.24619 2.5 4.16667C2.5 5.08714 3.24619 5.83333 4.16667 5.83333Z",
    fill: "#2F54EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExerciseExtremity);
export default __webpack_public_path__ + "static/media/icon_exercise_extremity.63d64908e1f83e698072d415dc12de03.svg";
export { ForwardRef as ReactComponent };